export default "__VITE_ASSET__DAatS_cB__"